import React from 'react';
import './trashButton.scss';
import { ReactComponent as Trash } from '../../assets/trash.svg';
import { TrashInterface } from './trashButtonTypes';

const TrashButton: React.FC<TrashInterface> = ({ onClick, animation }) => {
  const handleClick = (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    event.stopPropagation();
    onClick();
  };

  return (
    <button
      className={animation ? 'trashButton' : 'trashButtonNoHover'}
      type="button"
      onClick={handleClick}
    >
      <Trash className={animation ? 'trashIcon' : 'trashIconNoHover'} />
    </button>
  );
};

export default TrashButton;
